export default __webpack_public_path__ + "static/media/petal_axes.e1cc53fa.svg";